export default "__VITE_ASSET__0813b644__"